import { ScrollView } from 'react-native';
import { Flex, Typography } from '@banhala/ui-kit';
import type { RankingFilterCategory } from 'shared/src/api';

interface CategoryFilterProps {
  categories: RankingFilterCategory[];
  selectedSno: number | null;
  onSelect: (category: RankingFilterCategory) => void;
}

export const CategoryFilter = ({
  categories,
  selectedSno,
  onSelect,
}: CategoryFilterProps) => {
  if (categories.length === 0) return null;

  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={{ paddingHorizontal: 6 }}
    >
      <Flex.Row>
        {categories.map(category => {
          const isSelected = category.sno === selectedSno;
          return (
            <Flex
              key={category.sno}
              padding={{ vertical: 13, horizontal: 10 }}
              onPress={() => onSelect(category)}
            >
              <Typography
                type={isSelected ? 'subtitle2' : 'body2'}
                color={isSelected ? 'content_primary' : 'content_secondary'}
              >
                {category.name}
              </Typography>
            </Flex>
          );
        })}
      </Flex.Row>
    </ScrollView>
  );
};
